module.exports = __webpack_public_path__ + "../resources/img/ic_isolated_thunderstorms_weather.b63ca32b.svg";